
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{staticClass:"location-pin",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 19 22.69","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke-miterlimit":"10"}},[_c('path',{staticClass:"location-pin__outline",attrs:{"d":"M15.21 2.54A9 9 0 003.14 15.87L9.5 22c.44-.41 6.36-6.14 6.36-6.14s.23-.25.34-.38l.26-.27a9 9 0 00-1.25-12.67zM9.46 7.39a2.12 2.12 0 11-2.12 2.12 2.12 2.12 0 012.12-2.12z"}}),_c('path',{staticClass:"location-pin__circle",attrs:{"d":"M9.46 7.39a2.12 2.12 0 102.12 2.12 2.12 2.12 0 00-2.12-2.12z"}})])])
      }
    
      }
    


//////////////////
// WEBPACK FOOTER
// ./images/icons/icon-location-pin--outline.svg
// module id = 416
// module chunks = 0